//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

class String {
    static truncate(stringToTruncate, totalLength, truncatedStringEllipsis = '...') {
        if (stringToTruncate) {
            return (
                stringToTruncate.length > totalLength ?
                    stringToTruncate.substring(0, totalLength - truncatedStringEllipsis.length) + truncatedStringEllipsis
                    : stringToTruncate
            );
        }

        return stringToTruncate;
    }
}

export default String;
